<template>
    <div class="form-group input-group"
         :class="[
       {'has-danger': error},
       {'focused': focused},
       {'has-label': label || $slots.label},
       {'has-success': valid === true},
       {'has-danger': valid === false},
       formClasses
       ]">
        <slot name="label">
            <label v-if="label" class="form-control-label" :class="labelClasses">
                {{label}}
                <span v-if="required">*</span>
            </label>
        </slot>


            <div class="input-group-prepend">
            <span class="input-group-text"
                  :class="[appendSpanClasses]">
                <i class="far fa-file"></i>
            </span>
            </div>
            <slot v-if="mount" v-bind="slotData">
                <transition name="fade">

                <input v-if="(typeof getFilenameForSelected($refs.upload.documents,$refs.upload.file) === 'undefined' )"
                        v-on:click="modal = !modal"
                        :value="value"
                        :name="label"
                        v-on="listeners"
                        v-bind="$attrs"
                        class="form-control"
                        :class="[
                         {'is-valid': valid === true},
                         {'is-invalid': valid === false}, inputClasses]"
                        aria-describedby="addon-right addon-left">
                    <input v-else
                            v-on:click="modal = !modal"
                           :placeholder="getFilenameForSelected($refs.upload.documents,$refs.upload.file).fileName"
                            :name="label"
                            v-on="listeners"
                            v-bind="$attrs"
                            class="form-control"
                            :class="[inputClasses]"
                            aria-describedby="addon-right addon-left">
                </transition>
            </slot>
            <div class="input-group-append">
              <span class="input-group-text"
                    :class="[appendSpanClasses]">
                      <i class="fas fa-cloud-upload-alt"></i>
              </span>
            </div>
        <slot name="infoBlock"></slot>
        <slot name="helpBlock">
            <div class="text-danger invalid-feedback" style="display: block;" :class="{'mt-2': hasIcon}" v-if="error">
                {{ error }}
            </div>
        </slot>
        <modal :show.sync="modal"
               modal-classes="modal-xl">
            <h6 slot="header" class="modal-title" id="modal-title-default">Dokumentverwaltung</h6>

            <upload-field-main :url="url" ref="upload">
            </upload-field-main>
            <template v-if="mount" slot="footer">
                <base-button v-if="$refs.upload.file !== null" type="primary" @click="selectFile($refs.upload.file)">Ausgewählte Datei übernehmen</base-button>
                <base-button type="link" class="ml-auto" @click="modal = false">abbrechen
                </base-button>
            </template>
        </modal>
    </div>
</template>
<script>
import UploadFieldMain from "@/components/UploadField/main";
export default {
    components:{UploadFieldMain},
    inheritAttrs: false,
  name: "upload-field",
  props: {
        url: {
            type: String,
            description: "Api Url"
        },
    required: {
      type: Boolean,
      description: "Whether input is required (adds an asterix *)"
    },
    valid: {
      type: Boolean,
      description: "Whether is valid",
      default: undefined
    },
    label: {
      type: String,
      description: "Input label (text before input)"
    },
    error: {
      type: String,
      description: "Input error (below input)"
    },
    labelClasses: {
      type: String,
      description: "Input label css classes"
    },
    inputClasses: {
      type: [String, Array],
      description: "Input css classes"
    },
      formClasses: {
          type: [String, Array],
          description: "form css classes"
      },
      appendSpanClasses: {
          type: [String, Array],
          description: "Append span css classes"
      },
    value: {
      type: [String, Number],
      description: "Input value"
    },
    addonRightIcon: {
      type: String,
      description: "Addon right icon"
    },
    addonLeftIcon: {
      type: String,
      description: "Addon left icon"
    }
  },
  data() {
    return {
      focused: false,
        modal: false,
        mount: false,
    };
  },
    mounted() {
        this.mount = true;
        this.$refs.upload.file = this.value;
    },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: this.updateValue,
        focus: this.onFocus,
        blur: this.onBlur
      };
    },
    slotData() {
      return {
        focused: this.focused,
        ...this.listeners
      };
    },
      getSelectedName() {
        return this.getFilenameForSelected(this.$refs.upload.documents,this.$refs.upload.file);
      }
  },
  methods: {
        selectFile(fileid){
            let evt = {target: { value: fileid}};
           this.updateValue(evt);
           this.modal = !this.modal;
        },
      getFilenameForSelected(documents,file) {
          return documents.find(item => { return item['@id'] === file })
      },
    updateValue(evt) {
      let value = evt.target.value;
      this.$emit("input", value);
    },
    onFocus(value) {
      this.focused = true;
      this.$emit("focus", value);
    },
    onBlur(value) {
      this.focused = false;
      this.$emit("blur", value);
    }
  }
};
</script>
<style>

    .upload-field-modal {
        max-width: 640px;
    }


</style>
